<template>
  <div class="tab-part-replace-record">


    <div class="table-content">
      <div class="header">
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item style="float: right; margin-right: 0" v-if="funcView.account_order_replace_export">
              <el-button type="info" @click="onExport">
                <i class="icon icon-export-excel"></i>
                {{ $t('Common.com_export') }} Excel
              </el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
            </el-form-item>
            <el-form-item style="float: right" :class="!funcView.account_order_replace_export ? 'mr-0' : ''">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <el-form-item style="float: right">
              <search-input v-model="formSearch.search" :placeholder="$t('Common.com_serial_no')" @fetch="onPageChange({ page: 1 })"></search-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="query-filter">
      <div class="params-form"  v-show="isFilter">
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('tab_part_replace_record.gong_dan_bian_hao') }}</div>
              <div class="value">
                <el-input v-model="formSearch.caseOrderCode" @input="onOrderCodeChange" clearable :placeholder="$t('Common.com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('Common.com_location') }}</div>
              <div class="value">
                <el-input v-model="formSearch.locationName" @input="onLocationChange" clearable :placeholder="$t('Common.com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="8" v-if="isCoJv && showSubsidiary">
            <div class="item">
              <div class="label">{{ $t('tab_part_replace_record.gong_si_ming_cheng') }}</div>
              <div class="value">
                <el-input v-model="formSearch.customerName" @input="onCustomerNameChange" clearable :placeholder="$t('Common.com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('Common.com_filter_item') }}</div>
        <div class="values">
          <el-tag closable v-for="orderCodeTag in caseOrderCodeTagList" :key="orderCodeTag.value" @close="onCloseOrderCode(orderCodeTag.value)">{{ orderCodeTag.label }}</el-tag>
          <el-tag closable v-for="locationNameTag in locationNameTagList" :key="locationNameTag.value" @close="onCloseLocationName(locationNameTag.value)">{{ locationNameTag.label }}</el-tag>
          <el-tag closable v-for="customerNameTag in customerNameTagList" :key="customerNameTag.value" @close="onCloseCustomerName(customerNameTag.value)">{{ customerNameTag.label }}</el-tag>
          <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
        </div>
      </div>
    </div>
      <div class="table-bd">
        <custom-table
          tableCode="p_order_part_replace_record"
          height="100%"
          :stripe="true"
          :data="tableList"
          @column="setColumn"
          columnRef="column"
          @on-row-click="onRowClick"
          @filter="filterChange"
          @sort="sortChange"
          :filterArr="!isCoJv ? ['customerName'] : []"
        ></custom-table>
      </div>
      <div class="page-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customPagination from '@/components/customPagination';
import mixins from '@/pages/order/children/mixins';

export default {
  name: 'TabRepairOrder',
  mixins: [mixins],
  components: {
    customPagination,
  },
  props: {},
  data() {
    return {
      billType: 'maintainOrder',
      type: '',
      date1: '',
      project: '',
      tableList: [],
      totalRows: 0,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        locationName: '',
        caseOrderState: [],
        caseOrderType: [],
        search: '',
        // 公司名称
        customerName: '',
        // 工单编号
        caseOrderCode: '',
        showSubsidiary: '',
      },
      stateTagList: [],
      dateTagList: [],
      locationNameTagList: [],
      customerNameTagList: [],
      caseOrderCodeTagList: [],

      acceptanceCommentsVisible: false,
      acceptanceCommentsModel: {},
      isFilter: false,
    };
  },
  methods: {
    onSuccess() {
      this.onPageChange({ page: 1 });
    },

    onRowClick(e) {
      const query = {
        caseOrderId: e.caseOrderId,
        caseOrderCode: e.caseOrderCode,
      };
      this.jump('/service/order/detail/detail', query);
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },

    getReqData() {
      const ret = {
        ...this.formSearch,
      };
      if (this.formSearch.time) {
        ret.createStartTime = this.formSearch.time[0];
        ret.createEndTime = this.formSearch.time[1];
        ret.time = '';
      }
      return ret;
    },

    onExport() {
      this.exportTable('PortalWorkOrderExport', this.getReqData());
    },

    onClear() {
      this.stateTagList = [];
      this.dateTagList = [];

      this.locationNameTagList = [];
      this.customerNameTagList = [];
      this.caseOrderCodeTagList = [];

      this.formSearch.locationName = '';

      this.formSearch.customerName = '';
      this.formSearch.caseOrderCode = '';
      this.onPageChange({ page: 1 });
    },

    onLocationChange() {
      const locationName = this.formSearch.locationName.trim();
      if (locationName) {
        this.locationNameTagList = [
          {
            label: locationName,
            value: 'locationName',
          },
        ];
      } else {
        this.locationNameTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseLocationName() {
      this.formSearch.locationName = '';
      this.onLocationChange();
    },

    onOrderCodeChange() {
      const caseOrderCode = this.formSearch.caseOrderCode.trim();
      if (caseOrderCode) {
        this.caseOrderCodeTagList = [
          {
            label: caseOrderCode,
            value: 'caseOrderCode',
          },
        ];
      } else {
        this.caseOrderCodeTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseOrderCode() {
      this.formSearch.caseOrderCode = '';
      this.onOrderCodeChange();
    },
    onCustomerNameChange() {
      const customerName = this.formSearch.customerName.trim();
      if (customerName) {
        this.customerNameTagList = [
          {
            label: customerName,
            value: 'customerName',
          },
        ];
      } else {
        this.customerNameTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseCustomerName() {
      this.formSearch.customerName = '';
      this.onCustomerNameChange();
    },
    async init() {
      this.getTableList();
    },
    getTableList() {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.PortalWorkOrderPartPage, this.getReqData()).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
  },
  created() {},
  mounted() {
    this.getFuncView();
    this.init();
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';
.tab-part-replace-record {
  .table-content {
    border-radius: 16px;
    background: #fff;
    > .header {
      padding: 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }
      .search-content {
        float: right;
      }
    }
    .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 14px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    .table-bd {
      height: 416px;
      width: 100%;
      overflow: hidden;
      padding: 0 24px;
      margin-top: 24px;
    }

    .page-footer {
      height: 88px;
    }
  }
}
</style>
